(function () {
    if (!window.location.pathname.match(/\/pages\/venta-de-autos(\/.+)?/g)) return;
    /* setup external dependencies */
    var featherlight = require('featherlight');
    var car = require('../modules/TableLocationFiltering');

    /* setup jQuery opjects */
    var $dropdown = $('select#locations');
    var $locationElements = $('td.location');
    var $button = $('#update-table');

    /* actions */
    car.setupFiltering($locationElements, $button, $dropdown);
    car.addToDropdown(car.getLocations($locationElements), $dropdown);
})();
